import { z } from 'zod'

export const baseStorageSchema = z.object({
  type: z.enum(['S3']).optional(),
  docType: z.enum(['yDoc']).describe('Type of the document, e.g., yDoc').optional(),
  filename: z.string(),
})
export type Storage = z.infer<typeof baseStorageSchema>

export const s3StorageSchema = baseStorageSchema.extend({
  type: z.literal('S3').optional(),
  versionId: z.string().describe('Version ID of the file in S3').optional(),
})

export const storageSchema = s3StorageSchema

export type S3Storage = z.infer<typeof s3StorageSchema>

export function isStorage(node?: unknown): node is Storage {
  return storageSchema.safeParse(node).success
}

export function isS3Storage(node?: unknown): node is S3Storage {
  return s3StorageSchema.safeParse(node).success
}

export const yDocStorageSchema = s3StorageSchema.extend({
  docType: z.literal('yDoc'),
})
export type YDocStorage = z.infer<typeof yDocStorageSchema>

export function isYDocStorage(node?: unknown): node is YDocStorage {
  return yDocStorageSchema.safeParse(node).success
}

export const storageUrlsSchema = z.object({
  expiresAtISODateTime: z.iso.datetime(),
  /** main Url for the resource */
  url: z.string(),
  /** Audio: the URL to play. The playable copy when one exists (#2008), otherwise the same as `url`. */
  playbackUrl: z.string().describe('URL to play: the transcoded copy when one exists, else url').optional(),
})

export type StorageUrls = z.infer<typeof storageUrlsSchema>

/**
 * The URL to play or decode audio from: the playable copy when the server made one (#2008: MP3s Chrome cannot
 * decode), otherwise the file itself. Downloads use `url`.
 */
export const playbackUrlOf = (storageUrls?: StorageUrls) => storageUrls?.playbackUrl ?? storageUrls?.url

export const isStorageUrlsExpired = (storageUrls?: StorageUrls): boolean => {
  if (!storageUrls?.expiresAtISODateTime) {
    return false
  }
  return new Date(storageUrls.expiresAtISODateTime) < new Date()
}
